import { useCreateNormalCarleadForm } from './useCreateNormalCarleadForm';
export function useStep2CarleadForm() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStepsFunction;
  const step2Form = useCreateNormalCarleadForm([{
    createSteps: [function createSteps(currentSteps, formNames) {
      return typeof steps === 'function' ? steps(currentSteps, formNames) : steps;
    }]
  }, ...params]);
  return step2Form;
}
function defaultStepsFunction(_ref) {
  let [step1] = _ref;
  return [step1.filter(field => {
    return field !== 'manufacturer' && field !== 'mainType' && field !== 'builtDate';
  })];
}